// extracted by mini-css-extract-plugin
export default {"threshold":"style_threshold__I4Bdp"};